var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPremiumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "premium 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74194 8.28103L10.5714 3.89186C10.8053 3.62353 11.1445 3.46924 11.5001 3.46924C11.8556 3.46924 12.1949 3.62353 12.4287 3.89186L16.2582 8.28103L19.9123 5.97336C20.3215 5.71557 20.8438 5.72036 21.2482 5.98678C21.6527 6.2532 21.8635 6.73236 21.7868 7.21057L20.0503 18.0608C19.9152 18.908 19.184 19.5309 18.3272 19.5309H4.6729C3.81615 19.5309 3.08494 18.908 2.94982 18.0608L1.21332 7.21057C1.13665 6.73236 1.34748 6.2532 1.7519 5.98678C2.15632 5.72036 2.67861 5.71557 3.08782 5.97336L6.74194 8.28103ZM2.70448 7.43195L4.36911 17.8337C4.39307 17.9832 4.52148 18.0934 4.6729 18.0934H18.3272C18.4787 18.0934 18.6071 17.9832 18.631 17.8337L20.2957 7.43195L16.8773 9.59011C16.3636 9.91499 15.6899 9.81628 15.2903 9.35916L11.5001 5.01407L7.70986 9.35916C7.31023 9.81628 6.63653 9.91499 6.12286 9.59011L2.70448 7.43195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2021 14.4988C19.5989 14.4988 19.9209 14.8208 19.9209 15.2175C19.9209 15.6143 19.5989 15.9363 19.2021 15.9363H3.79785C3.4011 15.9363 3.0791 15.6143 3.0791 15.2175C3.0791 14.8208 3.4011 14.4988 3.79785 14.4988H19.2021Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumIcon);
export default __webpack_public_path__ + "static/media/premium_icon.52e0395578141615155c49dde2edc39f.svg";
export { ForwardRef as ReactComponent };